// src/components/UpgradeModal.js
import React, { useState, useContext, useEffect, useCallback } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axiosInstance from '../axiosConfig';
import { AuthContext } from '../AuthContext';
import './EntityModals.css';

function UpgradeModal({ show, handleClose, onSubmit }) {
    const { projects, setProjects, loadingProjects, selectedServiceCenter, authTokens } = useContext(AuthContext);
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        photo: null,
        project: '',
    });

    const fetchProjects = useCallback(async () => {
        if (!selectedServiceCenter || !selectedServiceCenter.id) {
            console.warn('Selected service center is not defined.');
            return;
        }

        try {
            const response = await axiosInstance.get(`/api/projects/?service_center=${selectedServiceCenter.id}`, {
                headers: {
                    'Authorization': `Bearer ${authTokens.access}`
                }
            });
            if (response.status === 200) {
                setProjects(response.data.projects || []); // Обновляем проекты в контексте
            }
        } catch (error) {
            console.error('Failed to fetch projects:', error);
        }
    }, [selectedServiceCenter, authTokens.access, setProjects]);

    useEffect(() => {
        if (show) {
            // Если модальное окно открыто, обновляем проекты
            fetchProjects();
        }
    }, [show, fetchProjects]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleFileChange = (e) => {
        setFormData((prevData) => ({
            ...prevData,
            photo: e.target.files[0],
        }));
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();

        const data = new FormData();
        for (const key in formData) {
            data.append(key, formData[key]);
        }

        axiosInstance.post('/api/create_upgrade/', data)
            .then(response => {
                if (response.data.success) {
                    onSubmit(response.data);
                    handleClose();  // Закрытие модального окна после успешного создания апгрейда
                } else {
                    console.error('Ошибка при создании апгрейда:', response.data.errors);
                    // Можно добавить отображение ошибок пользователю
                }
            })
            .catch(error => {
                console.error('Ошибка при создании апгрейда:', error);
                // Можно добавить отображение ошибок пользователю
            });
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            className="entity-modal"
            dialogClassName="entity-modal-dialog entity-modal-dialog--sm"
            contentClassName="entity-modal-content"
        >
            <Modal.Header closeButton>
                <Modal.Title>Добавить апгрейд</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleFormSubmit} className="entity-form">
                    <Form.Group controlId="formName" className="entity-field">
                        <Form.Label className="entity-label">Название</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <Form.Group controlId="formDescription" className="entity-field">
                        <Form.Label className="entity-label">Описание</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <Form.Group controlId="formPhoto" className="entity-field">
                        <Form.Label className="entity-label">Фото</Form.Label>
                        <Form.Control
                            type="file"
                            name="photo"
                            onChange={handleFileChange}
                        />
                    </Form.Group>
                    <Form.Group controlId="formProject" className="entity-field">
                        <Form.Label className="entity-label">Проект</Form.Label>
                        <Form.Control
                            as="select"
                            name="project"
                            value={formData.project}
                            onChange={handleChange}
                            required
                            disabled={loadingProjects}
                        >
                            <option value="">Выберите проект</option>
                            {projects.map(project => (
                                <option key={project.id} value={project.id}>
                                    {project.name}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                    <div className="entity-actions">
                        <Button className="entity-btn entity-btn-primary" type="submit">
                            Сохранить
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default UpgradeModal;
